module.exports = __webpack_public_path__ + "img/send-message-gray.07674cba.svg";